import React from 'react'

import { useSettings } from '../../hooks/useSettings'

const LungsSVG = ({ styles, isActive, isDisabled }) => {
  const { isDarkMode } = useSettings()

  const color = isDarkMode
    ? isActive
      ? '#8cb7ed'
      : '#ffffff'
    : isActive
      ? '#648cb5'
      : '#0E2E4C'

  return (
    <svg
      className={styles || 'pointer-events-none w-[31px] desktop:w-[35px] h-[31px] desktop:h-[35px]'}
      width="32"
      height="31"
      viewBox="0 0 32 31"
      fill="none"
      version="1.1"
      id="svg1"
      opacity={isDisabled ? '0.5' : '1'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs id="defs1" />

      <path
        d="m 25.178631,18.877298 c -8.31e-4,3.706438 -8.31e-4,3.706438 -3.46754,3.706438 -3.46754,0 -4.334411,-2.779814 -4.334411,-5.559686 0,-0.350238 -0.01561,-0.850635 -0.02254,-1.43622 l 1.753735,1.0832 0.0018,0.35302 c 0,2.572297 0.707359,3.706439 2.600615,3.706439 0.98824,0 1.395696,-0.0065 1.70172,-0.03522 0.02599,-0.325193 0.03207,-0.76164 0.03207,-1.817979 0,-2.969784 -0.609449,-5.590237 -1.590753,-7.320245 -0.726445,-1.28057 -1.398314,-1.7068136 -1.761501,-1.5780145 -0.254009,0.090806 -0.52449,0.6023005 -0.720415,1.5039025 L 17.819682,10.525739 C 18.139523,9.4165843 18.67095,8.5326008 19.543023,8.2212596 22.143691,7.2946475 25.181236,11.927683 25.178635,18.877301 Z M 13.474864,8.2212572 c 0.87294,0.3113411 1.404366,1.1953252 1.724206,2.3044798 l -1.551687,0.957202 C 13.451457,10.581336 13.180116,10.069846 12.926984,9.9790363 12.562892,9.8493109 11.891062,10.275555 11.165478,11.556143 10.1833,13.287059 9.5738835,15.907515 9.5738835,18.877298 c 0,1.056338 0.00606,1.491821 0.032078,1.81798 0.3060083,0.02873 0.7134405,0.03522 1.7016875,0.03522 1.893273,0 2.600623,-1.134143 2.600623,-3.706437 l 0.0035,-0.353929 1.753737,-1.082293 c -0.0087,0.586552 -0.0234,1.085983 -0.0234,1.436222 0,2.77987 -0.866871,5.559685 -4.334423,5.559685 -3.467527,0 -3.467527,0 -3.467527,-3.706438 0,-6.94962 3.034087,-11.5826534 5.634744,-10.6560413 z m 3.900949,-3.2431425 v 6.8773243 l 4.070865,2.512947 -0.866871,1.604894 -4.070865,-2.512038 -4.070878,2.512038 -0.866882,-1.604894 4.070887,-2.512947 V 4.9781147 Z"
        fill={color}
        id="path1"
      />
      <path
        d="M 30.038248,16.37934 C 29.935667,21.82998 24.136397,28.115624 16.32788,28.126548 8.0638706,28.228563 2.8445394,23.10309 2.6289193,16.392704 2.7600233,8.8983158 5.8653019,4.1059973 11.237851,3.9723336"
        fill="none"
        stroke={color}
        strokeWidth="2.9"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeDasharray="none"
        strokeOpacity="1"
        id="path6"
      />
      <path
        d="m 9.962037,1.1321393 0.0704,5.5133642 3.433001,-2.8189834 z"
        fill={color}
        fillOpacity="1"
        stroke={color}
        strokeWidth="1px"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeOpacity="1"
        id="path7"
      />
    </svg>
  )
}

export default LungsSVG
